import React from 'react'
let PropTypes = React.PropTypes

import * as css from './PanelAuditoria.css'
import { ModalTrigger, ModalRevisarVencimiento, ModalConfirmarEliminarCaptura } from './Modales.jsx'
import { sincronizarDesdeFechaExp } from './fechasVencimiento.js'

export class RowIRD extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            capturaIRD: this.props.capturaIRD
        }
        this.onInputChange = (key)=>{
            let actualizado = this.props.capturaIRD
            actualizado[key] = this.inputTotalConteo.value
            actualizado['editado'] = 1
            this.setState({ capturaIRD: Object.assign({}, this.state.capturaIRD, actualizado)})
        }
        this.onInputChangeFisico = (key)=>{
            let actualizado = this.props.capturaIRD
            actualizado[key] = this.inputTotalFisico.value
            actualizado['editado'] = 1
            this.setState({ capturaIRD: Object.assign({}, this.state.capturaIRD, actualizado)})
        }
        this.onInputChangeStock = (key)=>{
            let actualizado = this.props.capturaIRD
            actualizado[key] = this.inputTotalStock.value
            actualizado['editado'] = 1
            this.setState({ capturaIRD: Object.assign({}, this.state.capturaIRD, actualizado)})
        }
        this.cambioCheckbox = (evt)=>{
            let actualizado = {}
            let estado = evt.target.checked
            actualizado['malEnfocado'] = estado
            actualizado['editado'] = 1
            this.setState({ capturaIRD: Object.assign({}, this.state.capturaIRD, actualizado)}, ()=>this.guardaCaptura())

        }
        this.guardaCaptura = (key)=>{
            if(this.state.capturaIRD.editado)
                this.context.actualizaCapturaIRD(this.state.capturaIRD)
        }
        //Devuelve la promesa para que el modal de confirmación de la fila espere
        //la respuesta del backend antes de cerrarse (y bloquee el doble click).
        this.eliminarCapturaIRD = ()=>
            this.context.eliminarCapturaIRD(this.props.capturaIRD.idCapturaAuditoriaIrd)
        this.restaurarCaptura = ()=>{
            this.context.restaurarCapturaIRD(this.props.capturaIRD.idCapturaAuditoriaIrd)
        }
        this._colorFila = ()=>{
            let cap = this.props.capturaIRD
            const alerta = cap.critico == 2
            if (alerta)
                return "#F2F5A9"
            else
                return "white"
        }
    }
    render() {
        return (
            <tr key={this.props.index} className={css.rowSelect} style={{background: this._colorFila()}}>
                {/* Correlativo */}
                <td className={css.tdIndex} title={this.props.capturaIRD.idCapturaAuditoriaIrd}>{this.props.index+1}</td>
                <td className={css.tdModificaciones}>
                    <div className={css.divConTooltip}>
                        {this.props.capturaIRD.trazabilidad.length>0?
                            <span className={"glyphicon glyphicon-list"}></span>
                            :
                            <null></null>
                        }
                        <div className={css.tooltip}>
                            <table className={css.tablaTooltip}>
                                <tbody>
                                {this.props.capturaIRD.trazabilidad.map((trazabilidad, index)=>
                                    <tr key={index}><td>Cambio n°{index + 1}: {trazabilidad.descripcion}</td></tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </td>
                {/* SKU */}
                <td className={css.tdSku}>{this.props.capturaIRD.sku}</td>
                {/* Barra */}
                <td className={css.tdBarra}>{this.props.capturaIRD.barra}</td>
                {/* Descriptor */}
                <td className={css.tdDescriptor}>{this.props.capturaIRD.descriptor}</td>
                {/* Laboratorio */}
                <td className={css.tdLaboratorio}>{this.props.capturaIRD.laboratorio}</td>
                {/* Items */}
                <td className={css.tdItems}>{this.props.capturaIRD.items}</td>
                {/* Total Conteo */}
                <td className={css.tdTotalConteo}>
                    <input type="text" className={"form-control "+css.inputCaptura} placeholder="Total Stock Físico"
                           id={this.props.index}
                           ref={ref=>this.inputTotalFisico=ref}
                           value={this.props.capturaIRD.total_conteo}
                           onChange={this.onInputChangeFisico.bind(this, 'total_conteo')}
                           onBlur={this.guardaCaptura}
                           disabled={this.props.fcv}
                    />
                </td>
                {/* Stock Link */}
                <td className={css.tdTotalConteo}>{this.props.capturaIRD.teorico_link}</td>
                {/* Stock Pantalla */}
                <td className={css.tdTotalConteo}>
                    <input type="text" className={"form-control "+css.inputCaptura} placeholder="Total Stock Pantalla"
                           id={this.props.index}
                           ref={ref=>this.inputTotalStock=ref}
                           value={this.props.capturaIRD.teorico}
                           onChange={this.onInputChangeStock.bind(this, 'teorico')}
                           onBlur={this.guardaCaptura}
                           disabled={this.props.fcv}
                    />
                </td>
                {/* Stock */}
                <td className={css.tdStock}>
                    <p className={css.tooltip}>
                        <span className={"glyphicon glyphicon-search " +css.glyphiconStock}></span>
                        <span className={css.tooltiptext}>
                        <img src={`${this.props.capturaIRD.ruta_imagen}`} className={css.imagenStock}/>
                        </span>
                    </p>
                </td>
                {/* Teorico */}
                <td className={css.tdTeorico}>{this.props.capturaIRD.diferencia}</td>
                {/* Estado Borrosa */}
                <td className={css.tdSinRespaldo}>
                    <input
                        type="checkbox"
                        checked={this.state.capturaIRD.malEnfocado}
                        onChange={this.cambioCheckbox.bind(this)}
                        disabled={this.props.fcv}
                    />
                </td>
                {/* Eliminar */}
                <td className={css.tdEliminar}>
                    {!this.props.fcv ? (this.props.capturaIRD.estado !== 3?
                        <ModalTrigger>
                            {(isVisible, showModal, hideModal)=>
                                <div>
                                    <button className={"btn btn-xs btn-danger"}
                                        onClick={showModal}
                                        title={"Eliminar Captura"}
                                    >
                                        <span className={"glyphicon glyphicon-remove"}></span>
                                    </button>
                                    {isVisible && <ModalConfirmarEliminarCaptura
                                        titulo={'Eliminar captura IRD'}
                                        detalle={[
                                            {etiqueta: 'SKU', valor: this.props.capturaIRD.sku},
                                            {etiqueta: 'Barra', valor: this.props.capturaIRD.barra},
                                            {etiqueta: 'Descriptor', valor: this.props.capturaIRD.descriptor},
                                            {etiqueta: 'Laboratorio', valor: this.props.capturaIRD.laboratorio},
                                            {etiqueta: 'Total conteo', valor: this.props.capturaIRD.total_conteo}
                                        ]}
                                        mensaje={'¿Está seguro de marcar esta captura IRD como no válida?'}
                                        mensajeConfirmacion={'La captura quedará invalidada (puede restaurarla después). ¿Confirma?'}
                                        onConfirmar={this.eliminarCapturaIRD}
                                        hideModal={hideModal}
                                    />}
                                </div>
                            }
                        </ModalTrigger>
                        :
                            <button className={"btn btn-xs btn-info"} onClick={this.restaurarCaptura} title={"Restaurar Captura"}><span className={"glyphicon glyphicon-share-alt "+css.iconoEspejo}></span></button>
                    ): null}
                </td>
            </tr>
        )
    }
}
RowIRD.contextTypes = {
    actualizaCapturaIRD: PropTypes.func,
    eliminarCapturaIRD: PropTypes.func,
    restaurarCapturaIRD: PropTypes.func
}

export class RowVencimiento extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            capturaVencimiento: []
        }
        this.onLoteChange = (key)=>{
            let actualizado = this.props.capturaVencimiento
            actualizado[key] = this.inputLote.value
            actualizado['editado'] = 1
            this.setState({ capturaVencimiento: Object.assign({}, this.state.capturaVencimiento, actualizado)})
        }
        //Al corregir la Fecha Vencimiento (date) se recalcula en simultáneo la Fecha Juliana (fecha_venc)
        this.onFechaExpChange = ()=>{
            let actualizado = this.props.capturaVencimiento
            Object.assign(actualizado, sincronizarDesdeFechaExp(this.inputFechaExp.value))
            this.setState({ capturaVencimiento: Object.assign({}, this.state.capturaVencimiento, actualizado)})
        }
        this.guardaCaptura = ()=>{
            if(this.state.capturaVencimiento.editado)
                this.context.actualizaCapturaVencimiento(this.state.capturaVencimiento)
        }
        //El botón de eliminar de la fila (al lado del ojo "ver captura") pide confirmación
        //en un modal antes de eliminar, para no invalidar una captura por un click accidental.
        //Devuelve la promesa para que el modal se cierre cuando responde el backend.
        //El botón de restaurar (misma celda, captura en estado 3) no se confirma.
        this.eliminarCapturaVencimiento = ()=>
            this.context.eliminarCapturaVencimiento(this.props.capturaVencimiento.idCapturaAuditoriaVencimiento)
        this.restaurarCaptura = ()=>{
            this.context.restaurarCapturaVencimiento(this.props.capturaVencimiento.idCapturaAuditoriaVencimiento)
        }
        this._colorFila = ()=>{
            let cap = this.props.capturaVencimiento
            const alerta = cap.critico == 2
            if (alerta)
                return "#F2F5A9"
            else
                return "white"
        }
    }
    render() {
        return (
            <tr key={this.props.index} className={css.rowSelect} style={{background: this._colorFila()}}>
                {/* Correlativo */}
                <td className={css.tdIndex} title={this.props.capturaVencimiento.idCapturaAuditoriaVencimiento}>{this.props.index+1}</td>
                <td className={css.tdModificaciones}>
                    <div className={css.divConTooltip}>
                        {this.props.capturaVencimiento.trazabilidad.length>0?
                            <span className={"glyphicon glyphicon-list"}></span>
                            :
                            <null></null>
                        }
                        <div className={css.tooltip}>
                            <table className={css.tablaTooltip}>
                                <tbody>
                                {this.props.capturaVencimiento.trazabilidad.map((trazabilidad, index)=>
                                    <tr key={index}><td>Cambio n°{index + 1}: {trazabilidad.descripcion}</td></tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </td>
                {/* SKU */}
                <td className={css.tdSku}>{this.props.capturaVencimiento.sku}</td>
                {/* Barra */}
                <td className={css.tdBarra}>{this.props.capturaVencimiento.barra}</td>
                {/* Descriptor */}
                <td className={css.tdDescriptor}>{this.props.capturaVencimiento.descriptor}</td>
                {/* Laboratorio */}
                <td className={css.tdLaboratorio}>{this.props.capturaVencimiento.laboratorio}</td>
                {/* Codigo Vendedor */}
                <td className={css.tdSku}>{this.props.capturaVencimiento.cod_vendedor}</td>
                {/* Items */}
                <td className={css.tdItems}>{this.props.capturaVencimiento.items}</td>
                {/* Lote */}
                <td className={css.tdLote}>
                    <input type="text" className={"form-control "+css.inputLote} placeholder="Lote" 
                        id={this.props.index}
                        ref={ref=>this.inputLote=ref}
                        value={this.props.capturaVencimiento.lote}
                        onChange={this.onLoteChange.bind(this, 'lote')} 
                        onBlur={this.guardaCaptura}
                        disabled={this.props.fcv}
                    />
                </td>
                {/* Fecha Vencimiento */}
                <td className={css.tdFechExp}>
                    <input type="date" className={"form-control "+css.inputFechaExp} placeholder="Fecha Vencimiento" 
                        id={this.props.index} 
                        ref={ref=>this.inputFechaExp=ref}
                        value={this.props.capturaVencimiento.fecha_exp} 
                        onChange={this.onFechaExpChange} 
                        onBlur={this.guardaCaptura}
                        disabled={this.props.fcv}
                    />
                </td>
                {/* Vencido */}
                <td className={css.tdVencido}>{this.props.capturaVencimiento.vencido? "Si" : "No"}</td>
                {/* Vencido por Política */}
                <td className={css.tdPolitica}>{this.props.capturaVencimiento.vencido_politica? "Si" : "No"}</td>
                {/* Mal Enfocado */}
                <td className={css.tdMalEnfocado}>{this.props.capturaVencimiento.malEnfocado? "Si" : "No"}</td>
                {/* No Medible */}
                <td className={css.tdMalEnfocado}>{this.props.capturaVencimiento.noMedible? "Si" : "No"}</td>
                {/* Imagen */}
                <td className={css.tdImagen}>
                    <ModalTrigger>
                        {(isVisible, showModal, hideModal)=>
                            <div>
                                <span className={"glyphicon glyphicon-eye-open "+css.verImagen} onClick={showModal}/>
                                {isVisible && <ModalRevisarVencimiento
                                    hideModal={hideModal}
                                    index={this.props.index}
                                    capturaVencimiento={this.props.capturaVencimiento}
                                    local={this.props.local}
                                    auditor={this.props.auditor}
                                    fcv={this.props.fcv}
                                />}
                            </div>
                        }
                    </ModalTrigger>
                </td>
                {/* Eliminar */}
                <td className={css.tdEliminar}>
                    {!this.props.fcv? (this.props.capturaVencimiento.estado === 3?
                        <button className={"btn btn-xs btn-info"}
                            onClick={this.restaurarCaptura}
                            title={"Restaurar Captura"}
                        >
                            <span className={"glyphicon glyphicon-share-alt "+css.iconoEspejo}></span>
                        </button>
                        :
                        <ModalTrigger>
                            {(isVisible, showModal, hideModal)=>
                                <div>
                                    <button className={"btn btn-xs btn-danger"}
                                        onClick={showModal}
                                        title={"Eliminar Captura"}
                                    >
                                        <span className={"glyphicon glyphicon-remove"}></span>
                                    </button>
                                    {isVisible && <ModalConfirmarEliminarCaptura
                                        capturaVencimiento={this.props.capturaVencimiento}
                                        onConfirmar={this.eliminarCapturaVencimiento}
                                        hideModal={hideModal}
                                    />}
                                </div>
                            }
                        </ModalTrigger>)
                    : null}
                </td>
            </tr>
        )
    }
}
RowVencimiento.contextTypes = {
    actualizaCapturaVencimiento: PropTypes.func,
    eliminarCapturaVencimiento: PropTypes.func,
    restaurarCapturaVencimiento: PropTypes.func
}

export class RowNoEncontrado extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            noEncontrado: this.props.capturaNoEncontrado
        }
        this.onInputChange = (key)=>{
            let actualizado = {}
            actualizado[key] = this.inputStock.value
            actualizado['editado'] = 1
            this.setState({ noEncontrado: Object.assign({}, this.state.noEncontrado, actualizado)})
        }
        this.cambioCheckbox = (evt)=>{
            let actualizado = {}
            let estado = evt.target.checked
            actualizado['malEnfocado'] = estado
            actualizado['editado'] = 1
            this.setState({ noEncontrado: Object.assign({}, this.state.noEncontrado, actualizado)}, ()=>this.guardaCaptura())
            
        }
        this.guardaCaptura = ()=>{
            if(this.state.noEncontrado.editado)
                this.context.actualizarNoEncontrado(this.state.noEncontrado)
        }
        //Devuelve la promesa para que el modal de confirmación de la fila espere
        //la respuesta del backend (recarga de la auditoría incluida) antes de
        //cerrarse y así bloquear el doble click.
        this.eliminarCapturaNoEncontrado = ()=>
            this.context.eliminarCapturaNoEncontrado(this.props.capturaNoEncontrado.idCapturaNoEncontrado)
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* Correlativo */}
                <td className={css.tdIndex}>{this.props.index+1}</td>
                <td className={css.tdModificaciones}>
                    <div className={css.divConTooltip}>
                        {this.props.capturaNoEncontrado.trazabilidad.length>0?
                            <span className={"glyphicon glyphicon-list"}></span>
                            :
                            <null></null>
                        }
                        <div className={css.tooltip}>
                            <table className={css.tablaTooltip}>
                                <tbody>
                                {this.props.capturaNoEncontrado.trazabilidad.map((trazabilidad, index)=>
                                    <tr key={index}><td>Cambio n°{index + 1}: {trazabilidad.descripcion}</td></tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </td>
                {/* SKU */}
                <td className={css.tdSku}>{this.props.capturaNoEncontrado.sku}</td>
                {/* Descriptor */}
                <td className={css.tdDescriptor}>{this.props.capturaNoEncontrado.descriptor}</td>
                {/* Laboratorio */}
                <td className={css.tdLaboratorio}>{this.props.capturaNoEncontrado.laboratorio}</td>
                {/* Codigo Vendedor */}
                <td className={css.tdSku}>{this.props.capturaNoEncontrado.cod_vendedor}</td>
                {/* Estado */}
                <td className={css.tdVencido}>{this.props.capturaNoEncontrado.estado? "Obligatorio" : "Reserva"}</td>
                {/* Stock */}
                <td className={css.tdStockNo}>
                    <input type="text" className={"form-control "+css.inputCaptura} placeholder="Total Stock"
                           id={this.props.index}
                           ref={ref=>this.inputStock=ref}
                           value={this.state.noEncontrado.stock}
                           onChange={this.onInputChange.bind(this, 'stock')}
                           onBlur={this.guardaCaptura}
                           disabled={this.props.fcv}
                    />
                </td>
                {/* Imagen */}
                <td className={css.tdStock}>
                    <p className={css.tooltip}>
                        <span className={"glyphicon glyphicon-search " +css.glyphiconStock}></span>
                        <span className={css.tooltiptext}>
                        <img src={`${this.state.noEncontrado.ruta_imagen}`} className={css.imagenStock}/>
                        </span>
                    </p>
                </td>
                {/* Estado Borrosa */}
                <td className={css.tdBorrosa}>
                    <input
                        type="checkbox"
                        checked={this.state.noEncontrado.malEnfocado}
                        onChange={this.cambioCheckbox.bind(this)}
                        disabled={this.props.fcv}
                    />
                </td>
                {/* Eliminar */}
                <td className={css.tdEliminar}>
                    {!this.props.fcv ?
                        <ModalTrigger>
                            {(isVisible, showModal, hideModal)=>
                                <div>
                                    <button className={"btn btn-xs btn-danger"}
                                        onClick={showModal}
                                        title={"Eliminar Captura"}
                                    >
                                        <span className={"glyphicon glyphicon-remove"}></span>
                                    </button>
                                    {isVisible && <ModalConfirmarEliminarCaptura
                                        titulo={'Eliminar No Encontrado'}
                                        detalle={[
                                            {etiqueta: 'SKU', valor: this.props.capturaNoEncontrado.sku},
                                            {etiqueta: 'Descriptor', valor: this.props.capturaNoEncontrado.descriptor},
                                            {etiqueta: 'Laboratorio', valor: this.props.capturaNoEncontrado.laboratorio},
                                            {etiqueta: 'Vendedor', valor: this.props.capturaNoEncontrado.cod_vendedor},
                                            {etiqueta: 'Estado', valor: this.props.capturaNoEncontrado.estado? "Obligatorio" : "Reserva"},
                                            {etiqueta: 'Stock', valor: this.state.noEncontrado.stock}
                                        ]}
                                        mensaje={'¿Está seguro de eliminar este producto NO encontrado?'}
                                        mensajeConfirmacion={'Esta eliminación es definitiva y no se puede restaurar. ¿Confirma?'}
                                        onConfirmar={this.eliminarCapturaNoEncontrado}
                                        hideModal={hideModal}
                                    />}
                                </div>
                            }
                        </ModalTrigger>
                    : null}
                </td>
            </tr>
        )
    }
}
RowNoEncontrado.contextTypes = {
    actualizarNoEncontrado: PropTypes.func,
    eliminarCapturaNoEncontrado: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/RowCaptura.jsx